import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SliderSideCounterModule } from '@shared/core/components/slider/sliderTypes/sideCounter';
import { TileForLoyaltyMessageModule } from '@shared/core/components/tiles/tilesTypes/forLoyaltyMessage';
import { LoyaltyMessagesComponent } from './loyalty-messages.shared.component';

@NgModule({
    declarations: [
        LoyaltyMessagesComponent
    ],
    imports: [
        CommonModule,
        SliderSideCounterModule,
        TileForLoyaltyMessageModule
    ],
    exports: [
        LoyaltyMessagesComponent
    ]
})
export class LoyaltyMessagesModule { }
